import { createContext } from 'react'

export const CountersContext = createContext(null)

export const CountersActionsContext = createContext(null)
